<template lang="pug">
  nuxt-child

</template>

<script>
export default {
  scrollToTop: true,
  meta: {
    theme: 'paletta',
    logoText: 'colors'
  }
};
</script>
<style lang="stylus">
div.app.is-paletta
  overflow: hidden

.paletta
  *
    font-weight: $fontWeight-medium

  &-intro
    padding-top: unitRes(50, 200)
    padding-bottom: 200px
    position: relative
    z-index: 2

    +mq($until: 1500px)
      padding-bottom: 100px

    +mq($until: 'desktop')
      padding-bottom: 0

    &-img
      position: absolute
      top: -330px
      right: -520px
      z-index: -1

      +mq($until: 1500px)
        top: -200px

      +mq($until: 'desktop')
        width: 760px
        max-width: 760px

      +mq($until: 'mobile')
        width: 500px
        max-width: 500px
        right: -420px
        top: 0

  &-card
    cursor: pointer

    &-title
      text-align: center
      box-shadow: 0px 20px 59.5px 10.5px rgba(28, 29, 31, 0.07)
      padding: 15px 15px
      margin: 0
      font-weight: 600

  &-share
    font-size: unitRes(24, 30)

    >a
      display: inline-flex
      margin: 0 10px

  &-colors
    display: flex

    &-item
      width: 20%
      height: 80px
      border-radius: 0 0 20em 20em
      transition: transform 200ms
      transform-origin: top
      cursor: pointer

      &:hover
        transform: scaleY(1.2)

        span
          transform: scaleY(0.8)

      span
        display: block
        margin-top: -40px
        transition: transform 200ms
        transform-origin: top

      &.is-tall
        height: 160px

      &.has-text
        margin-top: 40px

        +mq($until: 'mobile')
          font-size: 12px

html[lang^='ar']
  .paletta-intro-img
    left: -520px
    right: auto
    transform: scaleX(-1)
    filter: FlipH

    +mq($until: 'mobile')
      left: -420px
      right: auto
</style>
